import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Equipment } from 'src/app/models/maintenance/equipment';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  IButtonlabelEdit,
  MessageService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
@Component({
    selector: 'app-equipment-table',
    templateUrl: './equipment-table.component.html',
    styleUrls: ['./equipment-table.component.scss'],
    standalone: false
})
export class EquipmentTableComponent implements OnInit {
  public labels: IButtonlabelEdit[] = [];
  public urlTableEquipment: string = `${EndpointDictionary.Equipment.EQUIPMENT_TABLE}`;

  @Input() equipment: Equipment;
  @Output() clickRow = new EventEmitter<Equipment>();
  @Output() continue = new EventEmitter<void>();

  public reloadTableEquipment = new EventEmitter<any>();
  public columnEquipment: TableColumns<Equipment>[] = [
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'brand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    }
  ];

  public configurationEquipment: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'id',
  };

  constructor(private message: MessageService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['equipment']?.currentValue) {
      let equipment = changes['equipment'].currentValue as Equipment;
      if (equipment.code) this.setLabel(equipment);
    }
  }

  clickRowEquipment($event: Equipment) {
    this.setLabel($event);
    this.clickRow.emit($event);
  }

  private setLabel(equipment: Equipment) {
    this.labels = [
      {
        label: 'Código del equipo: ',
        value: equipment.code,
        edit: false,
      },
    ];
  }

  validateEquipment() {
    if (!this.equipment || !this.equipment.id) {
      this.message.ErrorToast('Seleccione el equipo');
    } else {
      this.continue.emit();
    }
  }
}
